module.exports = __webpack_public_path__ + "img/Blast_Off_Club_House56.6cc89b95.jpg";